// 获取手机厂商
export function getBrand(ua = navigator.userAgent) {
  console.log('ua:',navigator.userAgent)
  if (isHuawei(ua)) {
    return 'huawei'
  } else if (isOppo(ua)) {
    return 'oppo'
  } else if (isXiaomi(ua)) {
    return 'xiaomi'
  } else if (isVivo(ua)) {
    return 'vivo'
  } else if (ua.indexOf('iphone') > -1) {
    return 'iphone'
  } else if (ua.indexOf('ipad') > -1) {
    return 'ipad'
  } else {
    return 'other'
  }
}

// 判断是否为华为
function isHuawei(ua) {
  return (
    ua.indexOf('huawei') > -1 ||
    ua.indexOf('honor') > -1 ||
    ua.indexOf('nova') > -1
  )
}

// 判断是否为OPPO
function isOppo(ua) {
  if (/(oppo|heytap)/g.test(ua)) {
    return true
  }
  var ret = false
  var otArr = [
    'oppo',
    'heytap',
    'pacm',
    'padt',
    'padm',
    'pafm',
    'pbam',
    'pbcm',
    'pbem',
    'pccm',
    'pbfm',
    'pcpm',
    'pcam',
    'pcdm',
    'pcem',
    'pcgm',
    'pdet',
    'pbbt',
    'pchm',
    'pckm',
    'pcat',
    'pckm',
    'pclm',
    'pcnm',
    'pcrt',
    'pdkt',
    'pcrm',
    'pdbm',
    'pdyt',
    'pbat',
    'pdcm',
    'pbdm',
    'pdhm',
    'pbft',
    'pdnt',
    'pcdt',
    'pcht',
    'pdat',
    'pbdt',
    'pbct',
    'pdvm',
    'pdpt',
    'pcct',
    'pbet',
    'peat',
    'pdpm',
    'pcet',
    'pdym',
    'peam',
    'pdnm',
    'pdkm',
    'rmx2051',
    'gm1901',
    'roselia',
    'rmx1971',
    'paam00',
    'rmx1851',
    'rmx1901',
    'rmx1931',
    'pdam',
    'pdem',
    'pbbm',
    '1107',
    '3007',
    'a31',
    'a31c',
    'a31t',
    'a51',
    'cph1607',
    'cph1717',
    'cph1723',
    'cph1801',
    'n1t',
    'n5117',
    'n5207',
    'n5209',
    'r2017',
    'r6007',
    'r7plus',
    'r7plusm',
    'r8107',
    'r8200',
    'r8205',
    'r8207',
    'r831s',
    'r833t',
    'x9000',
    'x9007',
    'x909',
    // 新增手机型号
    'pehm00',
    'pemm20',
    'pecm30',
    'peqm00',
    'pefm00',
    'pemm00',
    'perm00',
    'pegm00',
    'pegm10',
    'pfvm10',
    'pfgm00',
    'pdsm00',
    'pftm20'
  ]
  for (var i = 0; i < otArr.length; i++) {
    if (ua.indexOf(otArr[i]) > -1) {
      ret = true
      break
    }
  }
  return ret
}

// 判断是否为小米
function isXiaomi(ua) {
  if (1 < (ua.match(/.*(xiaomi|redmi|mix|mi).*/i) || []).length) {
    return true
  }
  var ret = false
  var otArr = [
    'm2007j22c',
    'm2006c3lc',
    'm2007j17c',
    'm2104k10ac',
    'm2012k11ac',
    'm2103k19c',
    'm2004j19c',
    'm2004j7ac',
    'm2003j15sc',
    'm2102j2sc',
    'm2101k9c',
    'm2011k2c',
    'm2002j9e',
    '21091116ac',
    'm2006j10c',
    '21091116c',
    'm2010j19sc',
    '22041216c',
    'm2012j11c',
    'm2007j3sc',
    '22041211ac',
    '22021211rc',
    'm2102k1ac',
    '2106118c',
    'm2102k1c'
  ]
  for (var i = 0; i < otArr.length; i++) {
    if (ua.indexOf(otArr[i]) > -1) {
      ret = true
      break
    }
  }
  return ret
}
// 判断是否为VIVO
function isVivo(ua) {
  return /(vivo|v1|v2)/g.test(ua)
}

export function getOsInfo() {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    return 'ios'
  }
  if (/(Android)/i.test(navigator.userAgent)) {
    //android
    return 'android'
  }
}

export function getNetworkType() {
  var ua = navigator.userAgent;
  var networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other';
  networkStr = networkStr.toLowerCase().replace('nettype/', '');
  var networkType;
  switch (networkStr) {
    case 'wifi':
      networkType = 'wifi';
      break;
    case '5g':
      networkType = '5g';
      break;
    case '4g':
      networkType = '4g';
      break;
    case '3g':
      networkType = '3g';
      break;
    case '3gnet':
      networkType = '3g';
      break;
    case '2g':
      networkType = '2g';
      break;
    case 'none':
      networkType = 'none';
      break;
    default:
      networkType = 'other';
  }
  return networkType;
}
